<template>
  <div class="view pm contracts">
    <div class="page">
      <div class="header">
        <h3 class="text-black mt-2 mb-3"><strong>Contracts Management</strong></h3>
      </div>
      <div class="content">
        <div class="card">
          <div class="card-header card-header-flex">
            <div class="d-flex flex-column justify-content-center mr-auto">
              <h5 class="mb-0">
                Projects List
                <span :key="meta.total" class="animated fadeIn">({{ meta.total }})</span>
              </h5>
            </div>

            <div class="d-flex flex-column justify-content-center">
              <span>
                <a-button type="default" icon="sync" class="mr-2" @click="fetch"> Refresh </a-button>
                <a-button type="primary" icon="user" @click="onNewContact"> New Contract </a-button>
              </span>
            </div>
          </div>
          <!-- table -->
          <ContractsListTable :contracts="contracts" :loading="loading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { ContractsListTable } from '@/components/reno/tables'

import options from '@/options'

const KEY = 'contracts'

export default {
  components: {
    ContractsListTable,
  },
  methods: {
    async fetch() {
      await this.$store.dispatch('pm/fetchAllContracts')
    },
    onNewContact() {
      this.$store.dispatch('pm/setNewContractMeta', {})
      this.$store.dispatch('pm/open', 'CREATE_CONTRACT')
    },
  },
  computed: {
    loading() {
      return this.$store.getters['pm/loading'](KEY)
    },
    contracts() {
      return this.$store.getters['pm/data'](KEY)
    },
    pagination() {
      return this.$store.getters['pm/pagination'](KEY)
    },
    meta() {
      return this.$store.getters['pm/meta'](KEY)
    },
  },
  async created() {
    await this.fetch()
  },
}
</script>

<style lang="scss" scoped></style>
